(() => {
  if (window.moebeDeliveryCountry) return;
  const manualKey = 'moebe.deliveryCountry.v1';
  const autoKey = 'moebe.detectedCountry.v1';
  const attemptKey = 'moebe.countryRedirect.v1';
  const maxAge = 6 * 60 * 60 * 1000;
  const current = document.querySelector('[data-moebe-current-country]');
  const available = new Set(Array.from(document.querySelectorAll('[data-moebe-country-option]'), option => option.dataset.value));
  const url = new URL(window.location.href);
  let resolvedCountry = null;
  let manualInProgress = false;
  const read = (storage, key) => {
    try { return window[storage].getItem(key); } catch { return null; }
  };
  const write = (storage, key, value) => {
    try { window[storage].setItem(key, value); } catch { /* Selection still works without browser storage. */ }
  };
  const valid = country => /^[A-Z]{2}$/.test(country || '') && available.has(country);
  const announce = country => {
    resolvedCountry = country;
    document.dispatchEvent(new CustomEvent('moebe:delivery-country-ready'));
  };
  const cacheDetected = country => write('sessionStorage', autoKey, JSON.stringify({ country, at: Date.now() }));
  const readDetected = () => {
    try {
      const data = JSON.parse(read('sessionStorage', autoKey));
      return data && valid(data.country) && Date.now() - data.at < maxAge ? data.country : null;
    } catch { return null; }
  };
  const prepare = (form, country, source = 'manual') => {
    if (!form || !valid(country)) return false;
    const target = new URL(window.location.href);
    target.searchParams.set('delivery_country', country);
    if (source === 'auto') target.searchParams.set('delivery_country_source', 'auto');
    else target.searchParams.delete('delivery_country_source');
    let input = form.querySelector('[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.append(input);
    }
    input.value = target.pathname + target.search + target.hash;
    return true;
  };
  const applyCountry = (country, source) => {
    if (!current || !valid(country) || manualInProgress) return;
    if (current.value === country) {
      if (source === 'auto') cacheDetected(country);
      announce(country);
      return;
    }
    // Stop a failed localization redirect from repeatedly reloading the page.
    const attempt = `${current.value}:${country}:${source}`;
    if (read('sessionStorage', attemptKey) === attempt ||
        (url.searchParams.get('delivery_country') === country && url.searchParams.get('delivery_country_source') === source)) return;
    const form = current.closest('form');
    if (!prepare(form, country, source)) return;
    write('sessionStorage', attemptKey, attempt);
    current.value = country;
    form.submit();
  };
  // Impulse submits disclosure forms with form.submit(), which bypasses submit events.
  document.addEventListener('click', event => {
    const option = event.target.closest('[data-moebe-country-option]');
    if (option) {
      manualInProgress = true;
      prepare(option.closest('form'), option.dataset.value);
    }
    if (event.target.closest('[data-disclosure-currency] [data-disclosure-toggle], .moebe-delivery__country')) manualInProgress = true;
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-moebe-country-form]')) {
      manualInProgress = true;
      prepare(event.target, new FormData(event.target).get('country_code'));
    }
  }, true);
  window.moebeDeliveryCountry = {
    isConfirmed: country => country === resolvedCountry || country === read('localStorage', manualKey)
  };
  const initialize = async () => {
    if (!current || !available.size) return;
    const requested = url.searchParams.get('delivery_country');
    const automatic = url.searchParams.get('delivery_country_source') === 'auto';
    if (!automatic && requested === current.value && valid(requested)) {
      write('localStorage', manualKey, requested);
      announce(requested);
      return;
    }
    const manual = read('localStorage', manualKey);
    if (valid(manual)) { applyCountry(manual, 'manual'); return; }
    if (automatic && requested === current.value && valid(requested)) {
      cacheDetected(requested);
      announce(requested);
      return;
    }
    const cached = readDetected();
    if (cached) { applyCountry(cached, 'auto'); return; }
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 4000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false`, {
        credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const data = await response.json();
      if (manualInProgress || valid(read('localStorage', manualKey))) return;
      const detected = data.detected_values?.country?.handle;
      if (valid(detected)) applyCountry(detected, 'auto');
    } catch { /* Keep the manual country prompt if detection is unavailable. */ }
    finally { window.clearTimeout(timeout); }
  };
  initialize();
})();
